webpackJsonp([259824459293384],{

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'isNew'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'isNew()'
	      ),
	      ' method returns true or false depending on whether or not the model has an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ', which is determined by whether there is an attribute with a name that matches the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'idAttribute'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'This method is used by ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'save()'
	        ),
	        ' to determine whether to ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'create'
	        ),
	        ' or ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'update'
	        ),
	        ' the resource. You can read more about that ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/models/methods/save/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      isNew: function() {\n        return !this.has(this.idAttribute);\n      },\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s use this code to illustrate:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend();\n\n      const t1 = new Tweet();\n      const t2 = new Tweet({\n        id: 2\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In the code above, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        't2.isNew()'
	      ),
	      ' will return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'true'
	      ),
	      ', because it has no ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ', whereas ',
	      _react2.default.createElement(
	        'code',
	        null,
	        't2.isNew()'
	      ),
	      ' would return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'false'
	      ),
	      ' because it ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'does'
	      ),
	      ' has an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Underneath, this method uses ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'idAttribute'
	      ),
	      ' to determine whether the model has an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      '. For example, take a look at this code:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        idAttribute: \'_id\'\n      });\n\n      const t1 = new Tweet({\n        _id: 1\n      });\n      const t2 = new Tweet({\n        id: 2\n      });\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this code, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        't1.isNew()'
	      ),
	      ' will now return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'false'
	      ),
	      ', because we defined the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'idAttribute'
	      ),
	      ' to be ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '_id'
	      ),
	      ', and it has one. And now ',
	      _react2.default.createElement(
	        'code',
	        null,
	        't2.isNew()'
	      ),
	      ' would return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'true'
	      ),
	      ' because it does ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'not'
	      ),
	      ' have an ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'id'
	      ),
	      ', according to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'idAttribute'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-properties-is-new-js-52a7c5f27e4a3eb044a5.js